import React from 'react';
import '../../../../mobilestyle.css';

const PositionChange = ({ change }) => {
  if (change === null || change === undefined) return null;
  if (change > 0) return <span className="v2-pos-change v2-pos-change--up">↑{change}</span>;
  if (change < 0) return <span className="v2-pos-change v2-pos-change--down">↓{Math.abs(change)}</span>;
  return <span className="v2-pos-change v2-pos-change--same">—</span>;
};

const LeaderboardItemAfterStage = ({ data, colorMapping, isHighlighted }) => {
  const inGroup = (data.inGroup || '').trim();
  const badgeColor = colorMapping[inGroup];
  const isOut = data.rowNumber === 'OUT';

  return (
    <div
      className={`v2-card${isHighlighted && !isOut ? ' row-highlight' : ''}`}
      style={isOut ? { background: '#f5f5f5', opacity: 0.7 } : undefined}
    >
      {/* Col 1: position + change indicator + start number badge */}
      <div className="v2-left">
        <div className="v2-pos">{data.rowNumber}</div>
        <PositionChange change={data.positionChange} />
        <div className="v2-num">#{data.positionNumber}</div>
      </div>

      {/* Col 2: driver / co-driver / class + car */}
      <div className="v2-middle">
        <div className="v2-d1">{(data.driverName || '').trim()}</div>
        <div className="v2-d2">{(data.coDriverName || '').trim()}</div>
        <div className="v2-car-row">
          {inGroup && (
            data.classPosition != null && data.classPosition !== 'OUT' ? (
              <span className="v2-split-badge" style={{ borderColor: badgeColor || '#ccc' }}>
                <span className="v2-split-badge-label" style={{ background: badgeColor || '#71717a' }}>{inGroup}</span>
                <span className="v2-split-badge-pos">
                  #{data.classPosition}
                  {data.classPositionChange > 0 && <span className="v2-cpos-up"> ↑{data.classPositionChange}</span>}
                  {data.classPositionChange < 0 && <span className="v2-cpos-down"> ↓{Math.abs(data.classPositionChange)}</span>}
                  {data.classPositionChange === 0 && <span className="v2-cpos-same"> —</span>}
                </span>
              </span>
            ) : (
              <span className="v2-class-badge" style={{ background: badgeColor || '#71717a' }}>{inGroup}</span>
            )
          )}
          <span className="v2-car">{(data.car || '').trim()}</span>
        </div>
      </div>

      {/* Col 3: total time + gaps */}
      <div className="v2-right">
        <div className="v2-time">{data.totalTime}</div>
        {data.penalty && data.rowNumber !== 'OUT' && (
          <div className="penalty">
            <div className="penalty-text">+{data.penalty}</div>
          </div>
        )}
        <div className="v2-gaps">
          <span><span className="v2-gap-label">L </span>{data.diffToFirst}</span>
          <span><span className="v2-gap-label">P </span>{data.diffToPrev}</span>
        </div>
      </div>
    </div>
  );
};

// Jawny komparator: obiekty wierszy są przebudowywane przy każdym przeliczeniu
// silnika, więc porównujemy renderowane pola zamiast referencji.
const ROW_FIELDS = [
  'rowNumber', 'positionNumber', 'driverName', 'coDriverName', 'car', 'inGroup',
  'classPosition', 'totalTime', 'penalty', 'diffToFirst', 'diffToPrev',
  'positionChange', 'classPositionChange',
];

const areEqual = (prevProps, nextProps) =>
  prevProps.isHighlighted === nextProps.isHighlighted &&
  prevProps.colorMapping === nextProps.colorMapping &&
  ROW_FIELDS.every((f) => prevProps.data[f] === nextProps.data[f]);

export default React.memo(LeaderboardItemAfterStage, areEqual);
